/**
 * Removes a key from a record without using the delete operator.
 * This avoids ESLint's @typescript-eslint/no-dynamic-delete warning.
 */
export const omitKey = <T>(record: Record<string, T>, keyToRemove: string): Record<string, T> => {
  const {[keyToRemove]: _, ...rest} = record;
  return rest;
};
